import { updateVendorDetails } from 'api/user/vendor_requests';
import Button from 'components/base/Button';
import { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import { updateProfileDetails } from 'redux-state/user/vendorSlice';

const EcomVendorPersonalInfo = () => {
  const dispatch = useDispatch();
  const vendorDetails = useSelector((state: RootState) => state.user.vendor);

  const [submitting, setSubmitting] = useState(false);
  const [phone, setPhone] = useState(vendorDetails?.phone || '');
  const [address, setAddress] = useState(
    vendorDetails?.address || {
      street: '',
      city: '',
      state: '',
      country: '',
      postalCode: ''
    }
  );

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);

    const profile = {
      phone,
      address
    };

    await updateVendorDetails(profile).then(res => {
      toast.success('Profile updated successfully');
      dispatch(updateProfileDetails(profile));
      setSubmitting(false);
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Row className="gx-3 gy-4 mb-5">
        <Col xs={12}>
          <h5 className="text-body-highlight mb-2">Phone</h5>
          <Form.Control
            type="text"
            placeholder="Enter your phone number"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            className="w-50"
          />
        </Col>
        <Col lg={12}>
          <Row className="g-4">
            <Col xs={4}>
              <Form.Group>
                <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                  Street
                </label>
                <Form.Control
                  type="text"
                  placeholder="Street"
                  value={address.street}
                  onChange={e =>
                    setAddress({ ...address, street: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                  City
                </label>
                <Form.Control
                  type="text"
                  placeholder="City"
                  value={address.city}
                  onChange={e =>
                    setAddress({ ...address, city: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                  State
                </label>
                <Form.Control
                  type="text"
                  placeholder="State"
                  value={address.state}
                  onChange={e =>
                    setAddress({ ...address, state: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                  Country
                </label>
                <Form.Control
                  type="text"
                  placeholder="Country"
                  value={address.country}
                  onChange={e =>
                    setAddress({ ...address, country: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <label className="form-label text-transform-none ps-0 fs-8 text-body-highlight">
                  Postal Code
                </label>
                <Form.Control
                  type="text"
                  placeholder="Postal Code"
                  value={address.postalCode}
                  onChange={e =>
                    setAddress({ ...address, postalCode: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>

        <Col xs={12} className="text-end">
          <Button
            type="submit"
            variant="primary"
            className="px-7"
            disabled={submitting}
          >
            {submitting ? 'Saving...' : 'Save changes'}
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default EcomVendorPersonalInfo;
